<template>
    <v-layout row>
        <v-flex xs12 sm4 offset-sm4 style="margin-top: 100px;">
            <v-progress-linear color="cyan" slot="extension" :indeterminate="true"  v-if="loading" class="ma-0"></v-progress-linear>
            <v-form v-model="valid" ref="form">
                <v-card justify-center>
                    <img  src="../assets/login.png" aspect-ratio="2.75"/>
                    <v-card-text primary-title>
                        <div>
                            <v-text-field v-model="txtusername" label="User Name" :rules="[(v) => !!v || 'User Name is required']" required autofocus></v-text-field>
                            <v-text-field v-model="txtpassword" label="Password" :rules="[(v) => !!v || 'Secret Code is required']" type="password" required></v-text-field>
                        </div>
                    </v-card-text>

                    <v-card-actions class="justify-center">
                        <v-btn block color="primary" v-bind:disabled="btnDisable" dark @click="auth">Sign In</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from 'axios';
export default {
    name: 'login',
    data() {
        return {
            txtusername: "",
            txtpassword: "",
            loading: false,
            valid: false,
            btnDisable: false
        }
    },
    computed: {
    },
    methods: {
    auth() {
        if(!this.$refs.form.validate()) {
            return false
        }
        this.loading = true;
        this.btnDisable = true;
        const user_name = this.txtusername
        const password = this.txtpassword
        const data = {crossDomain: true, 'username': user_name, 'password': password}
        const API_URL = this.$hostname + '/login'
        axios.post(API_URL, data, {'Access-Control-Allow-Origin': this.$basename, 'content-type': 'application/json'}).then(
            response => {
                if (response.status === 204) {
                    localStorage.clear();
                    alert('Check Login Details');
                    this.loading = false;
                    this.btnDisable = false;
                    return;
                }
                const token = response.data.token
                const username = response.data.username
                const user_dept = response.data.dept
                const role = response.data.role
                const role_name = response.data.role_name
                localStorage.setItem('jwt', token)
                localStorage.setItem('username', username)
                localStorage.setItem('user_dept', user_dept)
                localStorage.setItem('role', role)
                localStorage.setItem('role_name', role_name)
                this.loading = false;
                this.btnDisable = false;
                this.$router.push('/analytics')
            }, (error) => {
                localStorage.clear();
                this.btnDisable = false;
                this.loading = false;
                const message = error.message
                alert(message);
            });
        },
    clear() {
        this.txtpassword = "",
        this.txtusername = ""

    }
    }
};
</script>

